import { render, staticRenderFns } from "./OrderLogButtons.vue?vue&type=template&id=7356a18a"
import script from "./OrderLogButtons.vue?vue&type=script&lang=js"
export * from "./OrderLogButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports